(function () {
  const swiperInstances = new Map();

  function getSectionRoot(root) {
    if (!root) return null;
    if (root.classList && root.classList.contains('vecharge-charging-detail')) return root;
    return root.querySelector('.vecharge-charging-detail');
  }

  function destroyGallerySwiper(sectionId) {
    const instance = swiperInstances.get(sectionId);
    if (instance) {
      instance.destroy(true, true);
      swiperInstances.delete(sectionId);
    }
  }

  function initGallerySwiper(section) {
    const swiperEl = section.querySelector('[data-gallery-swiper]');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    const sectionId = section.id;
    destroyGallerySwiper(sectionId);

    const prevButton = section.querySelector('[data-gallery-prev]');
    const nextButton = section.querySelector('[data-gallery-next]');
    const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;

    if (slideCount === 0) return;

    const slidesDesktop = Number(swiperEl.dataset.slidesDesktop || 3);
    const slidesTablet = Number(swiperEl.dataset.slidesTablet || 2);
    const slidesMobile = Number(swiperEl.dataset.slidesMobile || 1);
    const spaceBetween = Number(swiperEl.dataset.spaceBetween || 16);

    const swiper = new Swiper(swiperEl, {
      slidesPerView: slidesMobile,
      spaceBetween: spaceBetween,
      loop: slideCount > slidesDesktop,
      speed: 500,
      grabCursor: true,
      watchOverflow: true,
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton
      },
      breakpoints: {
        750: {
          slidesPerView: slidesTablet,
          spaceBetween: spaceBetween
        },
        990: {
          slidesPerView: slidesDesktop,
          spaceBetween: spaceBetween
        }
      }
    });

    swiperInstances.set(sectionId, swiper);
  }

  function setVerticalTab(panel, tabName) {
    const tabs = panel.querySelectorAll('[data-vert-tab]');
    const panels = panel.querySelectorAll('[data-vert-panel]');

    tabs.forEach(function (tab) {
      const isActive = tab.dataset.vertTab === tabName;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    panels.forEach(function (contentPanel) {
      const isActive = contentPanel.dataset.vertPanel === tabName;
      contentPanel.classList.toggle('is-active', isActive);
      contentPanel.hidden = !isActive;
    });
  }

  function initVerticalTabs(panel) {
    const tabs = panel.querySelectorAll('[data-vert-tab]');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setVerticalTab(panel, tab.dataset.vertTab);
      });
    });

    const activeTab = panel.querySelector('[data-vert-tab].is-active');
    setVerticalTab(panel, activeTab ? activeTab.dataset.vertTab : 'description');
  }

  function setHorizontalTab(section, tabIndex) {
    const horizTabs = section.querySelectorAll('[data-horiz-tab]');
    const horizPanels = section.querySelectorAll('[data-horiz-panel]');

    horizTabs.forEach(function (tab) {
      const isActive = Number(tab.dataset.horizTab) === tabIndex;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    horizPanels.forEach(function (panel) {
      const isActive = Number(panel.dataset.horizPanel) === tabIndex;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;

      if (isActive) {
        initVerticalTabs(panel);
      }
    });
  }

  function initProductTabs(section) {
    const tabsRoot = section.querySelector('[data-product-tabs]');
    if (!tabsRoot) return;

    const horizTabs = tabsRoot.querySelectorAll('[data-horiz-tab]');
    if (!horizTabs.length) return;

    horizTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setHorizontalTab(tabsRoot, Number(tab.dataset.horizTab));
      });
    });

    const activeTab = tabsRoot.querySelector('[data-horiz-tab].is-active');
    setHorizontalTab(
      tabsRoot,
      activeTab ? Number(activeTab.dataset.horizTab) : 0
    );
  }

  function initChargingDetailSection(root) {
    const section = getSectionRoot(root);
    if (!section) return;

    initGallerySwiper(section);
    initProductTabs(section);
  }

  function initAllChargingDetailSections(root) {
    root.querySelectorAll('.vecharge-charging-detail').forEach(function (section) {
      initChargingDetailSection(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllChargingDetailSections(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initChargingDetailSection(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    const section = getSectionRoot(event.target);
    if (section) destroyGallerySwiper(section.id);
  });
})();
